import { render, staticRenderFns } from "./Finish24.vue?vue&type=template&id=1235801b&scoped=true&"
import script from "./Finish24.vue?vue&type=script&lang=js&"
export * from "./Finish24.vue?vue&type=script&lang=js&"
import style0 from "./Finish24.vue?vue&type=style&index=0&id=1235801b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235801b",
  null
  
)

export default component.exports